// Subcategory data with images
export const subcategoryImages = {
    // Pizza subcategories
    "Classic Pizza": "🍕",
    "Specialty Pizza": "🍕",

    // Main Course subcategories
    "Rice Dishes": "🍚",
    Curry: "🍛",

    // Salad subcategories
    "Green Salads": "🥗",
    Mediterranean: "🥗",

    // Dessert subcategories
    "Hot Desserts": "🍰",
    "Cold Desserts": "🍰",

    // Beverage subcategories
    "Traditional Drinks": "🥤",
    "Fresh Juices": "🧃",
    Coffee: "☕",

    // Default
    all: "📋",
};

export const getSubcategoryImage = (subcategory) => {
    return subcategoryImages[subcategory] || "📋";
};
